<template>
	<div class="serial-wrap">
		<!--		<flow-action v-model="_config.children" :nodes="_define?.childrenNodes?.nodes||[]">-->
		<!--			<template #reference>-->
		<!--				<el-button  type="success" plain round>{{_define?.childrenNodes?.title}}</el-button>-->
		<!--			</template>-->
		<!--		</flow-action>-->
		<flow-render v-for="(item,index) in _config.children" v-bind="_define?.props||{}" :_config="item"
					 :_parent="_config" :key="item.id||index"
					 :_index="index" @add-node="(name)=>handleAddNode(index,name)"
					 @del-node="_config.children.splice(index,1)" @node-click="(v)=>$emit('node-click',v)"></flow-render>
		<!--		<flow-action v-model="_config.children" :nodes="_define?.childrenNodes?.nodes||[]"></flow-action>-->
	</div>

</template>

<script>
import FlowRender from "@/components/flow/flow-render.vue";
// import FlowAction from "@/components/flow/nodes/flow-action.vue";

export default {
	components: {FlowRender},
	props: {
		_config: {
			type: Object
		},
		_parent: {
			type: Object, default: () => ({})
		},
		_define: {
			type: Object
		},
		_index:{
			type:Number,
		}
	},
	setup(props) {
		const handleAddNode = (index, node) => {
			props._config.children.splice(index + 1, 0, Object.assign(node.default() || {}, {
				name: node.name,
			}))
		}

		return {
			handleAddNode
		}
	}
}
</script>

<style lang="scss" scoped>
.serial-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
